import { render, staticRenderFns } from "./TaskViewDatePopup.vue?vue&type=template&id=35c05584&scoped=true&lang=pug&"
import script from "./TaskViewDatePopup.vue?vue&type=script&lang=js&"
export * from "./TaskViewDatePopup.vue?vue&type=script&lang=js&"
import style0 from "./TaskViewDatePopup.vue?vue&type=style&index=0&id=35c05584&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c05584",
  null
  
)

export default component.exports